var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _vm.isMessage
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-margin",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "row", attrs: { id: "title" } }, [
        _c("div", { staticClass: "col-1" }, [
          _c(
            "svg",
            {
              staticClass: "bd-placeholder-img mr-2 rounded",
              attrs: {
                id: "header",
                width: "28",
                height: "28",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid slice",
                focusable: "false",
                role: "img",
                "aria-label": "Placeholder: 32x32",
              },
            },
            [
              _c("rect", {
                attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
              }),
            ]
          ),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "col-3" }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-info",
              attrs: { id: "backBtn", type: "button" },
              on: { click: _vm.back },
            },
            [_vm._v("キャンセルする")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-8" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.register.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.roomname,
                          expression: "roomname",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        maxlength: "40",
                        autocomplete: "off",
                        placeholder: "チーム名",
                        required: "",
                      },
                      domProps: { value: _vm.roomname },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.roomname = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-3" }, [
                    _c("label", [_vm._v("メンバー（最大50名）")]),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.openModal },
                      },
                      [_vm._v("追加する")]
                    ),
                  ]),
                  _c("div", { staticClass: "col-9" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-sm table-hover form-table table-striped table-bordered",
                      },
                      [
                        _vm._m(2),
                        _c(
                          "tbody",
                          _vm._l(_vm.members, function (member) {
                            return _c("tr", { key: member.userId }, [
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-sm",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.remove(member.userId)
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "times-solid",
                                      attrs: { src: "/times-solid.svg" },
                                    }),
                                  ]
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(member.user.userCode))]),
                              _c("td", [_vm._v(_vm._s(member.user.userName))]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn btn-block",
                  attrs: { id: "register_button", type: "submit" },
                },
                [_vm._v("登録する")]
              ),
            ]
          ),
        ]),
      ]),
      _c("MemberModal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showContent,
            expression: "showContent",
          },
        ],
        attrs: {
          members: _vm.members,
          parentName: _vm.name,
          exclusionId: _vm.roomId,
          realms: _vm.realms,
        },
        on: {
          "close-modal": _vm.closeModal,
          "add-member": function ($event) {
            return _vm.addMember($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("チャットチーム新規作成")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("チーム名称")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "80px" }, attrs: { scope: "col" } }),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("ID")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("名称")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }